import React, { useEffect, useRef, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import api from "../../services/api";
import { errorMessage } from "../CrmRelationship/helpers";
import useStyles from "./styles";

export default function SettingsDialog({ settings, onClose, onSaved }) {
  const classes = useStyles();
  const [minutes, setMinutes] = useState(String(settings.waitingMinutes));
  const [version, setVersion] = useState(settings.version);
  const [busy, setBusy] = useState(false);
  const [conflict, setConflict] = useState(false);
  const [error, setError] = useState("");
  const alive = useRef(true);
  const working = useRef(false);
  useEffect(() => () => { alive.current = false; }, []);
  const save = async event => {
    event.preventDefault();
    if (working.current || conflict) return;
    if (!/^\d+$/.test(minutes) || Number(minutes) < 1 || Number(minutes) > 10080) { setError("Informe um prazo entre 1 e 10080 minutos."); return; }
    working.current = true; setBusy(true); setError("");
    try {
      await api.put("/crm/attention/settings", { waitingMinutes: Number(minutes), version });
      if (alive.current) { setBusy(false); onSaved(); }
    } catch (err) {
      if (alive.current) { setError(errorMessage(err)); setConflict(err.response?.status === 409); }
    } finally { working.current = false; if (alive.current) setBusy(false); }
  };
  const reload = async () => {
    if (working.current) return;
    working.current = true; setBusy(true); setError("");
    try {
      const { data } = await api.get("/crm/attention", { params: { type: "all", limit: 1 } });
      if (alive.current) { setMinutes(String(data.settings.waitingMinutes)); setVersion(data.settings.version); setConflict(false); }
    } catch (err) { if (alive.current) setError(errorMessage(err)); }
    finally { working.current = false; if (alive.current) setBusy(false); }
  };
  return <Dialog open fullWidth maxWidth="xs" onClose={() => { if (!busy) onClose(); }} aria-labelledby="attention-settings-title">
    <form onSubmit={save}>
      <DialogTitle id="attention-settings-title">Quando destacar uma espera?</DialogTitle>
      <DialogContent><div className={classes.dialogFields}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField autoFocus required id="attention-waiting-minutes" label="Tempo sem resposta (minutos)" variant="outlined" type="number" value={minutes} disabled={busy} onChange={event => setMinutes(event.target.value)} inputProps={{ min: 1, max: 10080, step: 1 }} helperText="Este prazo vale para toda a empresa." />
        <Typography variant="body2" color="textSecondary">A espera começa na primeira mensagem do cliente ainda sem resposta. Respostas públicas do atendente ou do bot encerram a espera.</Typography>
        <Typography variant="body2" color="textSecondary">Retornos entram no painel assim que vencem. Este ajuste não envia mensagens.</Typography>
        {conflict && <Button disabled={busy} onClick={reload}>Recarregar configuração</Button>}
      </div></DialogContent>
      <DialogActions><Button disabled={busy} onClick={onClose}>Fechar</Button><Button type="submit" variant="contained" color="primary" disabled={busy || conflict}>{busy ? "Salvando..." : "Salvar"}</Button></DialogActions>
    </form>
  </Dialog>;
}
